// Pure date-range rules for the users alerts management report's custom mode.

const parseDay = (value) => {
  if (typeof value !== 'string' || !value) return NaN;
  return Date.parse(value); // YYYY-MM-DD parses as UTC midnight
};

/**
 * A custom report range must be chronological and span at most one calendar
 * year (inclusive: Apr 15 2025 -> Apr 15 2026 is allowed).
 * Returns { valid: true } or { valid: false, error: <translation key> }.
 */
export const validateReportRange = (from, to) => {
  const fromMs = parseDay(from);
  const toMs = parseDay(to);
  if (isNaN(fromMs) || isNaN(toMs) || toMs < fromMs) {
    return { valid: false, error: 'invalid_dates' };
  }
  return { valid: true };
};

// Filename fragment per mode; monthly keeps the report's historical
// unpadded "YYYY-M" form so existing saved-file conventions don't change.
export const reportFileLabel = (mode, month, from, to) => {
  if (mode === 'custom') {
    return `${from}_${to}`;
  }
  const date = new Date(month);
  return `${date.getFullYear()}-${date.getMonth() + 1}`;
};
